<template>
  <div class="dropdown dropdown-actions">
    <!-- <b-dropdown
      v-if="isAdmin && (organisation || top)"
      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
      class="btn-icon"
      split
      text="Add New"
      variant="primary"
      right
    > -->
    <!-- <b-dropdown-item v-if="isAdmin && top" v-ripple.400="'rgba(113, 102, 240, 0.15)'" @click="onClickNewOrganisation">
        <FeatherIcon icon="HomeIcon" size="24" class="icon" />
        Organisation
      </b-dropdown-item> -->
    <!--      <b-dropdown-item v-if='organisation' v-ripple.400="'rgba(113, 102, 240, 0.15)'" @click='onClickNewGroup'>
        <FeatherIcon icon='UsersIcon' size='24' class='icon' />
        Group
      </b-dropdown-item>-->
    <!-- <b-dropdown-item v-if="organisation" v-ripple.400="'rgba(113, 102, 240, 0.15)'" @click="onClickNewUser">
        <FeatherIcon icon="UserIcon" size="24" class="icon" />
        User
      </b-dropdown-item> -->
    <!-- </b-dropdown> -->
    <b-button
      v-if="isAdmin && top"
      v-ripple.320="'rgba(40, 199, 111, 0.15)'"
      size="sm"
      class="modal-button ml-auto btn-action"
      variant="primary"
      @click="onClickNewOrganisation"
    >
      Add Organisation
    </b-button>
    <b-button
      v-if="isAdmin && organisation"
      v-ripple.320="'rgba(40, 199, 111, 0.15)'"
      size="sm"
      class="modal-button ml-auto btn-action"
      variant="primary"
      @click="onClickNewUser"
    >
      Add User
    </b-button>
    <AddUserToGroup ref="addUserToGroup" />
  </div>
</template>
<script>
import Ripple from 'vue-ripple-directive'
import { VBModal } from 'bootstrap-vue'
import routeTypeMixin from '@/components/content/routeTypeMixin'
import AddUserToGroup from '@/components/add/AddUserToGroup'

export default {
  name: 'Add',
  components: { AddUserToGroup },
  directives: {
    Ripple,
    'b-modal': VBModal
  },
  mixins: [routeTypeMixin],
  props: {},
  computed: {
    organisation() {
      return this.routeType() === 'organisation'
    },
    group() {
      return this.routeType() === 'group'
    },
    top() {
      return this.routeType() === 'top'
    },
    isAdmin() {
      return JSON.parse(localStorage.getItem('profile')).isAdmin
    }
  },
  methods: {
    onClickNewOrganisation() {
      this.$store.dispatch('homeAddNew/onChangeModal', { self: this, visible: true, entityType: 'organisation' })
    },
    onClickNewGroup() {
      this.$store.dispatch('homeAddNew/onChangeModal', { self: this, visible: true, entityType: 'group' })
    },
    onClickNewUser() {
      this.$store.dispatch('homeAddNew/onChangeModal', {
        self: this,
        visible: true,
        entityType: 'user',
        organisationId: this.$route.params.organisationId
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.icon {
  margin-right: 10px;
}

.btn-add {
  margin-left: 30px;
}

.btn-action {
  margin-top: 10px;
}
</style>
